import React from 'react'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import Loader from '../../components/Loader/Loader'
import Navbar from '../../components/Navbar/Navbar'
import Sidebar from '../../components/Sidebar/Sidebar'
import hurrayImg from './hurray.png'
import Swal from 'sweetalert2'

const Grades = () => {
  const [isLoading, setisLoading] = useState(false)
  let params = useParams()

  return (
    <>
      <Loader active={isLoading} />
      <Navbar />
      <div className="grid grid-flow-col grid-cols-5">
        <Sidebar courseId={params.id} />
        <div className="flex flex-col col-span-4 pt-24 border-l-2 pl-5 education-bg">
          <p className="text-5xl font-nunito font-extralight px-10">Grades</p>
          <div className="grid grid-cols-2">
            <div className="font-nunito text-blackOlive p-10 pt-36">
              <h1 className="text-3xl">Your Scores:</h1>
              <p className="text-lg text-gray-600 pt-5">Assignment Score: NA</p>
              <p className="text-lg text-gray-600">Exam Score: NA</p>
              <button
                className="bg-blue-500 my-6 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                onClick={(e) => {
                  fetch(
                    `${process.env.REACT_APP_API}/course/complete/${params.id}`,
                    {
                      method: 'PUT',
                      headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${sessionStorage.getItem(
                          'token'
                        )}`,
                      },
                    }
                  ).then((res) => {
                    setisLoading(false)
                    Swal.fire({
                      title: 'Success',
                      text: "Course Marked Completed",
                      icon: 'success',
                      confirmButtonColor: '#3085d6',
                    })
                  })
                }}
              >
                Mark Course as Complete
              </button>
            </div>
            <img src={hurrayImg} alt="hurray"></img>
          </div>
        </div>
      </div>
    </>
  )
}

export default Grades
